import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Select,
  Dropdown,
  Menu,
  Button,
  Divider,
} from "antd";

//  This function (refreshAllDeviceList) is currently not in use, when using this in future read below comments
//  Kindly note "fetchv1DeviceDetailsEndPoint" (which is used by refreshAllDeviceList) end point has been switched from V2 to V1,
//  when using this function kindly take care of making payload related changes
import {
  refreshAllDeviceList,
  fetchOrganization,
  fetchLocation,
} from "../../global/utility/Utils";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  downloadRequest,
  downloadFailure,
  downloadSuccess,
} from "../../store/actions/devices";
import { Box, Tooltip } from "@mui/material";
import { Checkbox } from "@vds/checkboxes"
import Online from "../../assets/wifi-wireless small.svg";
import Offline from "../../assets/offlinewifi.svg";
import Fullbattery from "../../assets/Fullbattery.svg";
import Fullsignal from "../../assets/Fullsignal.svg";
import Weaksignal from "../../assets/weeksignal.svg";
import lowsignal from "../../assets/lowsignal.svg";
import Lowbattery from "../../assets/lowbattery.svg";
import FilterCloseIcon from "../../assets/filter_gray.svg";
import FilterselectIcon from "../../assets/filter-blue.svg";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import DevicesMapView from "../Location/DevicesMapView";
import { stateVal } from "../../model/addSensorInputs";
import blackOk from "../../assets/blackhealth.svg";
import bluetooth from "../../assets/bluetooth.svg";
import router from "../../assets/router.svg";
import { CloseOutlined } from "@ant-design/icons";
import { fetchRequest } from "../../store/actions/devices";
import { calculateSerialMac } from "../../global/utility/macAddress";
import "./devicelist.css";
import {
  DropdownFilterWithCheckboxAndInitialValue,
  DropdownFilterWithSearch,
  DropdownFilterWithSearchAndCheckbox,
} from "../../components/DropdownFilter";
import CreateUserModel from "./EditDeviceModal";
import BulkDeviceDetails from "./BulkDeviceDetails";
import EditDevice from "./EditDevice";
import ToastNotification from "../../global/components/ToastNotification";

// import DropdownFilterWithMultipleCheckbox from "../../components/DropdownFilters/DropdownFilterWithMultipleCheckbox";

const { Option } = Select;

const DeviceList = (props) => {
  const {
    permissions,
    setConnectFilter,
    connectFilter,
    assetTypeFilter,
    setAssetTypeFilter,
    setFilteredData,
    filteredData,
  } = props;
  const { state } = useLocation();
  const [gatewayOrganizationFilter, setGatewayOrganizationFilter] =
    useState(null);
  const [locationFilter, setLocationFilter] = useState(null);
  const [organizationFilter, setOrganizationFilter] = useState(null);
  const [deviceType, setDeviceType] = useState([]);
  const [activeType, setActiveType] = useState([]);
  const [visible, setVisible] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});
  const [selectedDeviceDetails, setSelectedDeviceDetails] = useState(null);
  const [viewMode, setViewMode] = useState("list");
  const [isModalVisible, setIsModalVisible] = useState(!!state?.addNewdevice);
  const [isBulkModalVisible, setBulkIsModalVisible] = useState(false);
  const [searchOrgName, setOrgName] = useState(
    state?.hasOwnProperty("organizationId") ? [state?.organizationId] : ""
  );
  const [searchLocName, setLocName] = useState(
    state?.hasOwnProperty("location") ? [state?.location] : ""
  );
  const [open, setOpen] = useState(false);
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const isDownloaded = useSelector((state) => state.asset.isDownloaded);
  const isLoading = useSelector((state) => state.devices.isLoading);
  const deviceCounts = useSelector((state) => state.devices.deviceCounts);
  const filters = useSelector((state) => state.devices.filters);
  const healthStatusList = useSelector(
    (state) => state.devices.data.healthStatusList
  );
  const deviceConnectedStatusList = useSelector(
    (state) => state.devices.data.deviceConnectedStatusList
  );
  const activeStatusList = useSelector(
    (state) => state.devices.data.activeStatusList
  );
  const deviceTypeList = useSelector(
    (state) => state.devices.data.deviceType
  );
  const deviceList = useSelector((state) => state.devices.data.devices);
  const devicefilterList = useSelector(
    (state) => state.devices.data.deviceslist
  );
  const locationList = useSelector((state) => state.devices.data.locations);

  const organizationList = useSelector(
    (state) => state.devices.data.organizations
  );

  const locations = useSelector((state) => state.alert.data.locations);
  const organizations = useSelector((state) => state.alert.data.organizations);


  const locationObj = useLocation();

  const { organization, location } = locationObj.state || {
    organization: "",
    locationId: "",
  };

  const closebulkPopup = () => {
    setBulkIsModalVisible(false);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    // setSelectedUserr(null);
  };
  const openSingleModal = (id) => {
    setSelectedDeviceDetails(id);
    setIsModalVisible(true);
    // setSelectedUserr(null);
  };
  function capitalizeFirstLetter(name) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }
  const navigate = useNavigate();
  useEffect(() => {
    if (
      state?.hasOwnProperty("location") &&
      state?.hasOwnProperty("org_name")
    ) {
      setOrganizationFilter(state?.org_name);
      setLocationFilter(state?.location);
    }
    if (state?.data?.length !== 0) {
      setAssetTypeFilter(state?.data);
    }
  }, [state]);

  const devicemapview = (record, value = "devicemap") => {
    localStorage.removeItem("statevalue");
    if (record) {
      let devicedetails;
      if (value === "devicedetails") {
        devicedetails = {
          Lastreported: record.Lastreported,
          assetName: record.assetName,
          assetType: record.assetType,
          kind: record.kind,
          location: record.location,
          organization: record.organization,
          customdata: record.customdata,
          uid: record.uid,
          fields: record.fields,
          refid: record?.refid,
          lastupdated: record?.lastupdated,
          name: record.name.value,
          deviceName: record.name,
          description: record?.value?.description,
        };
      }
      localStorage.setItem(
        "state",
        JSON.stringify(
          value === "devicedetails" ? devicedetails : record,
          null,
          1
        )
      );
      navigate(`/devices/${record?.uid}/map`, {
        state: value === "devicedetails" ? devicedetails : record,
      });
    }
  };

  const dummyData = deviceList?.map((val, index) => {
    let value = val?.name || "";

    if (
      (val?.kind === "ts.device.tgAssetTracker" ||
        val?.kind === "ts.device.cHeAssetTracker") &&
      value === ""
    ) {
      if (val?.providerid) {
        if (val?.imei) {
          value = `GAT${val?.imei}`;
        } else if (val?.refid) {
          value = `GAT${val?.refid}`;
        } else if (val?.qrcode) {
          value = `GAT${val?.qrcode}`;
        }
      } else {
        value = "Unknown";
      }
    }

    return {
      key: `${val?.id}-${index}-${val?.name}`,
      name: {
        id: val?.id,
        value:
          val?.kind === "ts.device.tgAssetTracker" ||
          val?.kind === "ts.device.cHeAssetTracker"
            ? value
            : val?.name,
      },
      value: val,
      kind: val?.kind,
      Location:
        !val?.customdata?.locationName || val?.customdata?.locationName === ""
          ? "UNKNOWN"
          : val?.customdata?.locationName,
      associationName:
        (!val?.customdata?.shipmentname || val?.customdata?.shipmentname === "") &&
          (!val?.customdata?.assetname || val?.customdata?.assetname === "")
          ? ""
          : val?.customdata?.shipmentname || val?.customdata?.assetname,
      deviceStatus: val?.customdata?.connectionStatus
        ? val?.customdata?.connectionStatus
        : "UNKNOWN",
      healthStatus: val?.customdata?.healthStatus
        ? val?.customdata?.healthStatus
        : "UNKNOWN",
      fields: val?.fields,
      uid: val?.uid,
      refid: val?.refid,
      deviceName: val?.name,
      deviceType:val?.devicetype,
      customdata: val?.customdata,
      lastupdated: val?.lastupdated,
      action: (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item>
                <ul
                  className="dropdown-menu text-capitalize show"
                  data-popper-placement="left-end"
                  style={{
                    position: "absolute",
                    top: "-4px",
                    right: "-56px",
                    transform: "translate3d(-51px, -0.5px, 0px)",
                  }}
                >
                  <li>
                    <h6 className="font-face-vzw-header">Links</h6>
                  </li>
                  {permissions?.devices?.view ? (
                    <li>
                      <li
                        className="dropdown-item px-3"
                        onClick={() => devicemapview(val)}
                      >
                        View Device map
                      </li>
                    </li>
                  ) : null}
                  {permissions?.alarms?.view ? (
                    <li>
                      <Link
                        className="dropdown-item px-3"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/alerts", {
                            state: {
                              deviceId: val?.name,
                              deviceName: val?.name,
                            },
                          });
                        }}
                        data-turbo-frame="_top"
                      >
                        View Device Alerts
                      </Link>
                    </li>
                  ) : null}
                  {permissions?.assets?.view &&
                  val?.kind === "ts.device.ble" ? (
                    <li>
                      <Link
                        className="dropdown-item px-3"
                        to={`/devices/${val?.uid}/map`}
                        data-turbo-frame="_top"
                        state={val}
                      >
                        View Asset Map
                      </Link>
                    </li>
                  ) : null}
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <h6 className="font-face-vzw-header">Filters</h6>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item px-3"
                      to="/devices"
                      data-turbo-frame="_top"
                      onClick={(event) =>
                        handleListDeviceTypeClick(val?.kind, event)
                      }
                    >
                      Filter list by Device model
                    </Link>
                  </li>
                  <li>
                    <h6 className="font-face-vzw-header">Actions</h6>
                  </li>
                  {permissions?.devices?.edit ? (
                    <li>
                      <div
                        className="dropdown-item px-3"
                        data-turbo-frame="_top"
                        role="button"
                        href="javascript:void(0);"
                        onClick={() => openSingleModal(val)}
                      >
                        Edit Device
                      </div>
                    </li>
                  ) : null}
                </ul>
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <button
            className="btn btn-link text-secondary"
            data-bs-toggle="dropdown"
            onClick={(e) => e.preventDefault()}
          >
            <i className="bi-three-dots-vertical fs-6" />
          </button>
        </Dropdown>
      ),
    };
  });

  const handleListDeviceTypeClick = (value, event) => {
    event.preventDefault();
    dispatch(fetchRequest({ ...filters, deviceType: [value] || "" }));
  };
  const handleAssetFilterChange = (val) => {
    const activeFilters = Object.keys(val.filters)
      .filter((key) => val.filters[key])
      .map((key) => key);
    dispatch(fetchRequest({ ...filters, healthStatus: activeFilters || [] }));
  };
  const handleAssetResetFilterChange = (val) => {
    dispatch(fetchRequest({ ...filters, healthStatus: [] }));
  };

  const handleLocationFilterChange = (val) => {
    dispatch(fetchRequest({ ...filters, location: val.filteredResult || {} }));
  };

  const handleLocationResetFilterChange = (val) => {
    dispatch(fetchRequest({ ...filters, location: {} }));
  };

  const handleConnectFilterChange = (val) => {
    const activeFilters = Object.keys(val.filters)
      .filter((key) => val.filters[key])
      .map((key) => key);
    dispatch(
      fetchRequest({
        ...filters,
        deviceConnectedStatus: activeFilters || [],
      })
    );
  };
  const handleConnectResetFilterChange = (val) => {
    dispatch(
      fetchRequest({
        ...filters,
        deviceConnectedStatus: [],
      })
    );
  };
  const handleTableChange = (pagination) => {
    if (
      Object.hasOwn(pagination, "current") &&
      filters.pagenumber !== pagination.current - 1
    ) {
      dispatch(
        fetchRequest({ ...filters, pagenumber: pagination.current - 1 })
      );
    }
  };
  const handlePageSizeChange = (page, pageSize) => {
    dispatch(fetchRequest({ ...filters, limitnumber: pageSize }));
  };

  const handleSearchDeviceName = (val) => {
    dispatch(
      fetchRequest({
        ...filters,
        deviceName: val?.filters?.text || "",
        sort: [
          {
            field: "name",
            order: val.isAsc ? "asc" : "desc",
          },
        ],
      })
    );
  };
  const handleSearchResetDeviceName = (val) => {
    dispatch(
      fetchRequest({
        ...filters,
        deviceName: "",
        sort: [
          {
            field: "createdon",
            order: "desc",
          },
        ],
      })
    );
  };
  const handleDeviceTypeFilterChange = (e) => {
    const value = e;
    setDeviceType((prev) => {
      if (prev.includes(value)) {
        return prev.filter((item) => item !== value);
      }
      return [...prev, value];
    });
  };
  const handleApplyFilter = () => {
    setOpen(false);
    dispatch(
      fetchRequest({
        ...filters,
        activeStatus: activeType || "",
        deviceType: deviceType || "",
      })
    );
  };

  const handleResetFilter = () => {
    setOpen(false);
    setDeviceType([]);
    setActiveType([]);
    dispatch(fetchRequest({ ...filters, activeStatus: {}, deviceType: {} }));
  };

  const handleDownload = async () => {
    try {
      dispatch(downloadRequest("deviceList", filters));

      if (!navigator.onLine) {
        dispatch(downloadFailure("Export failed"));
        throw new Error("Network connection error");
      }
      setNotificationProps({
        type: "success",
        message: "Export",
        description: "Export completed successfully.",
        duration: 1,
        style: { backgroundColor: "#d4edda", color: "#155724" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
    } catch (error) {
      setNotificationProps({
        type: "error",
        message: "Export",
        description: "Export failed. Please check your network connection.",
        duration: 5,
        style: { backgroundColor: "#FFECE0", color: "black" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 3000);
    }
  };
  const refreshTheData = () => {
    dispatch(fetchRequest({ ...filters }));
  };

  const handleAssociationstSearch = (val) => {
    let order = val.isAsc ? "asc" : "desc";
    let associationsFilter = "";
    if (val.filteredResult && val.filteredResult.length > 0) {
      associationsFilter = val.filteredResult;
    } else if (val.filters?.text) {
      associationsFilter = val.filters.text;
    }
    dispatch(
      fetchRequest({
        ...filters,
        sort: [{ field: "name", order }],
        associationname: associationsFilter,
      })
    );
  };

  const handleAssociationSearchReset = () => {
    dispatch(
      fetchRequest({
        ...filters,
        sort: [{ field: "createdon", order: "asc" }],
        associationname: "",
      })
    );
  };

  const columns = [
    {
      title: (
        <DropdownFilterWithCheckboxAndInitialValue
          text="Status"
          isSortable={false}
          onApply={handleConnectFilterChange}
          onReset={handleConnectResetFilterChange}
          menuItems={deviceConnectedStatusList?.map((name) => ({
            text: name?.label,
            value: name.value,
          }))}
        />
      ),
      dataIndex: "deviceStatus",
      render: (text) =>
        viewMode !== "map" ? (
          text === "OFFLINE" ? (
            <Box className="font-face-vzw device-status-offline">Offline</Box>
          ) : (
            capitalizeFirstLetter(text)
          )
        ) : (
          ""
        ),

      onFilter: (value, record) => {
        if (value === "Select All") return true;
        return record.organization === value;
      },
    },
    {
      title: (
        <DropdownFilterWithCheckboxAndInitialValue
          text="Severity"
          isSortable={false}
          onApply={handleAssetFilterChange}
          onReset={handleAssetResetFilterChange}
          menuItems={healthStatusList?.map((name) => ({
            text: name?.label,
            value: name.value,
          }))}
        />
      ),
      dataIndex: "healthStatus",
      render: (text) =>
        viewMode !== "map" ? (
          text === "ERROR" || text === "CRITICAL" ? (
            <Box className="font-face-vzw alarm-condition-error ">Critical</Box>
          ) : (
            capitalizeFirstLetter(text?.toLowerCase() === "major"? "Warning":text?.toLowerCase() === "minor"?"Notification":text)
          )
        ) : (
          ""
        ),

      onFilter: (value, record) => {
        if (value === "Select All") return true;
        return record.assetType === value;
      },
    },
   
    {
      title: (
        <DropdownFilterWithSearch
         accountId={user?.accountId}
          text="Device name"
          isSortable={true}
          value={filters?.deviceName || ""}
          onApply={handleSearchDeviceName}
          onReset={handleSearchResetDeviceName}
        />
      ),
      dataIndex: "kind",
      showSorterTooltip: false,
      onHeaderCell: (column) => ({
        "data-tooltip": "",
      }),
      render: (kind, record) => (
        <Box>
          {" "}
          <li
            className="asset-hover-effect"
            onClick={() => devicemapview(record, "devicedetails")}
            style={{ color: "black" }}
          >
            <img
              style={{ marginTop: -3 }}
              alt="profile-user"
              width="20px"
              height={"20px"}
              src={
                kind === "ts.device.tgAssetTracker" ||
                kind === "ts.device.cHeAssetTracker"
                  ? router
                  : bluetooth
              }
            />
            {"  "}
            {record?.name?.value}
          </li>
          {kind === "ts.device.ble" ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              {record?.deviceType?.toUpperCase()?.startsWith("MOCO SMART - N2") ? (
                <div style={{ marginLeft: 7, marginTop: 6 }}>
                  <span>
                    MAC:{" "}
                    {record?.value?.mac ||
                      calculateSerialMac(record?.value?.serial)}
                  </span>
                </div>
              ) : (
                !record?.deviceType?.startsWith("Reelable") && (
                  <div style={{ marginLeft: 7, marginTop: 6 }}>
                    <span>Major: {record?.value?.major}</span>
                    <span style={{ paddingLeft: 10 }}>
                      Minor: {record?.value?.minor}
                    </span>
                  </div>
                )
              )}
              <div>
                {record.customdata.gatewayName && (
                  <span
                    style={{
                      backgroundColor: "#A7A7A7",
                      paddingLeft: 6,
                      paddingRight: 6,
                      paddingTop: 5,
                      paddingBottom: 5,
                      color: "white",
                      fontSize: 12,
                      borderRadius: 2,
                    }}
                  >
                    {record.customdata.gatewayName}
                  </span>
                )}
              </div>
            </div>
          ) : (
            kind === "ts.device.tgAssetTracker" && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                }}
              >
                <div style={{ marginTop: 6 }}>
                  <span>IMEI: {record?.value?.imei}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                  }}
                >
                  <span
                    style={{
                      backgroundColor:
                        record?.value?.fields?.signalStrength > -96
                          ? "#006FC1"
                          : record?.value?.fields?.signalStrength > -96 &&
                            record?.value?.fields?.signalStrength < -105
                          ? "#006FC1"
                          : "#FF8027",
                      paddingLeft: 8,
                      marginRight: 5,
                      paddingRight: 8,
                      borderRadius: 2,
                      minWidth: 60,
                      height: 25,
                      paddingTop: 3,
                      paddingBottom: 1,
                      textAlign: "center",
                      color: "white",
                      fontSize: 12,
                    }}
                  >
                    <img
                      alt="profile-user"
                      width="16px"
                      height={"16px"}
                      src={
                        record?.value?.fields?.signalStrength > -96
                          ? Fullsignal
                          : record?.value?.fields?.signalStrength > -96 &&
                            record?.value?.fields?.signalStrength < -105
                          ? lowsignal
                          : Weaksignal
                      }
                      style={{ marginTop: -3, marginLeft: -3, marginRight: 5 }}
                    />{" "}
                    {record?.value?.fields?.signalStrength}
                  </span>
                  <span
                    style={{
                      backgroundColor:
                        record?.value?.fields?.battery > 20
                          ? "#006FC1"
                          : record?.value?.fields?.battery < 20
                          ? "#FF8027"
                          : "red",
                      paddingLeft: 8,
                      paddingRight: 8,
                      borderRadius: 2,
                      paddingTop: 3,
                      paddingBottom: 1,
                      minWidth: 60,
                      height: 25,
                      textAlign: "center",
                      color: "white",
                      fontSize: 12,
                    }}
                  >
                    <img
                      alt="profile-user"
                      width="20px"
                      height={"20px"}
                      src={
                        record?.value?.fields?.battery > 20
                          ? Fullbattery
                          : Lowbattery
                      }
                      style={{ marginTop: -3, marginLeft: -3, marginRight: 5 }}
                    />
                    {record?.value?.fields?.battery}
                  </span>
                </div>
              </div>
            )
          )}
        </Box>
      ),
      SortOrder: "assend",
    },
   
    (user?.role?.name?.toLowerCase()?.startsWith("pharma") ? {
      title: (
        <DropdownFilterWithSearchAndCheckbox
          text="Location"
          isSortable={false}
          onApply={handleLocationFilterChange}
          onReset={handleLocationResetFilterChange}
          checkboxItems={locationList?.map((option) => ({
            text: option?.value,
            value:
              searchLocName &&
              Array.isArray(searchLocName) &&
              searchLocName.length > 0
                ? searchLocName[0] === option?.value
                : false,
            // value: false
          }))}
        />
      ),
      dataIndex: "Location",
      onFilter: (value, record) => {
        if (value === "Select All") return true;
        return record.location === value;
      },
    } : {}),
    {
      title: (
        <DropdownFilterWithSearch
          accountId={user?.accountId}
          text="Associations"
          isSortable={false}
          value={filters?.associationname || ""}
          onApply={handleAssociationstSearch}
          onReset={handleAssociationSearchReset}
        />
      ),
      dataIndex: ["shipmentname", "assetname"],
      render: (text, record) => (
        <>
          {record.associationName && <div> {record.associationName}</div>}
        </>
      ),
      onFilter: (value, record) => {
        if (value === "Select All") return true;
        return record.associationName === value;
      },
    },
    {
      title: <span className="font-face-vzw" style={{ fontWeight: '800', fontSize: '18px' }}>
      Device model
    </span>,

      dataIndex: "deviceType",
      render: (text) => (
        <div style={{ display: "flex" }}>
          <p className="mb-0">{text}</p>
        </div>
      ),
      // width: "12.5%", // Equal width
    },
    {
      title: (
        <div>
          <Dropdown
            visible={open} // Use `open` instead of `visible` to control dropdown state
            onVisibleChange={handleOpenChange} // Handle opening and closing based on `onOpenChange`
            overlay={
              <Menu>
                <Menu.Item>
                  <div
                    className="dropdown-menu show"
                    style={{
                      minWidth: 213,
                      position: "absolute",
                      top: "20px",
                      right: "-53px",
                      margin: 0,
                      transform: "translate3d(-51px, -36.5px, 0px)",
                    }}
                    data-popper-placement="left-end"
                  >
                    <h6 className="font-face-vzw-header">Additional filters</h6>
                    <div className="px-3">
                      {/* Device model Filter */}
                      <div className="ats-filter">
                        <span
                          className="font-face-vzw-title"
                          style={{ fontSize: "14px" }}
                        >
                          Device model
                        </span>
                        <img
                          src={FilterCloseIcon}
                          alt="filter-icon"
                          style={{ margin: "0 15px" }}
                        />
                      </div>
                      {deviceTypeList.map((option) => (
                        <div className="checkbox-container" key={option.value}>
                          <div style={{ marginLeft: -9 }}>
                            <Checkbox
                              className="filter-checkbox"
                              name={option.value}
                              selected={deviceType?.includes(option.value)}
                              onChange={() => handleDeviceTypeFilterChange(option.value)}
                              id={`device-type-${option.value}`}
                              surface="light"
                            >
                              {option.label}
                            </Checkbox>
                          </div>
                        </div>
                      ))}
                      <div
                        style={{ marginLeft: -10 }}
                        className="ats-filter-footer"
                      >
                        <button
                          className="reset-filter"
                          onClick={handleResetFilter}
                        >
                          Reset filter
                        </button>
                        <Button
                          className="ats-filter-footer-button"
                          color="default"
                          variant="solid"
                          onClick={handleApplyFilter}
                        >
                          Apply
                        </Button>
                      </div>
                    </div>
                    <Divider style={{ color: "#D8DADA", margin: "15px 0" }} />
                    <h6 className="font-face-vzw-header">Views</h6>
                    <Link
                      className="dropdown-item mb-2"
                      data-controller="data-download"
                      data-action="click->data-download#downloadCsv"
                      data-data-download-notification-title-value="Downloading"
                      data-data-download-url-value="/assets/download"
                      data-data-download-filename-value="assets_download.csv"
                      onClick={() => {
                        setOpen(false);
                        setViewMode("list");
                      }}
                    >
                      View as list
                    </Link>
                    <Link
                      className="dropdown-item"
                      data-controller="data-download"
                      data-action="click->data-download#downloadCsv"
                      data-data-download-notification-title-value="Downloading"
                      data-data-download-url-value="/assets/download"
                      data-data-download-filename-value="assets_download.csv"
                      onClick={() => {
                        setOpen(false);
                        setViewMode("map");
                      }}
                      style={{ marginTop: -10 }}
                      // onClick={handleClick}
                    >
                      View as map
                    </Link>
                    <Divider style={{ color: "#D8DADA", margin: "15px 0" }} />
                    <h6 className="font-face-vzw-header">Actions</h6>
                    {permissions?.devices?.edit ? (
                      <div
                        className="dropdown-item px-3"
                        data-turbo-frame="_top"
                        role="button"
                        href="javascript:void(0);"
                        onClick={() => {
                          setOpen(false);
                          setBulkIsModalVisible(true);
                        }}
                      >
                        Bulk edit
                      </div>
                    ) : null}

                    {permissions?.devices?.download ? (
                      <a
                        className="dropdown-item px-3"
                        data-controller="data-download"
                        data-action="click->data-download#downloadCsv"
                        data-data-download-notification-title-value="Downloading"
                        data-data-download-url-value="/assets/download"
                        data-data-download-filename-value="assets_download.csv"
                        onClick={handleDownload}
                      >
                        Export
                      </a>
                    ) : null}
                  </div>
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
          >
            <button
              className="btn btn-link text-secondary"
              data-bs-toggle="dropdown"
              onClick={(e) => e.preventDefault()}
            >
              <i className="bi-three-dots-vertical fs-6" />
            </button>
          </Dropdown>
          {isBulkModalVisible && (
            <BulkDeviceDetails
              visible={isBulkModalVisible}
              onClose={closebulkPopup}
              locationList={locationList}
              deviceList={deviceList}
              organizationList={organizationList}
              onBulkUpdated={() => {
                closebulkPopup();
                refreshTheData();
              }}
            />
          )}
        </div>
      ),
      dataIndex: "action",
    },
  ];

  return (
    <div
      style={{
        marginTop: "20px",
        backgroundColor: "#fff",
        borderRadius: "12px",
      }}
    >
      {showNotification && (
        <ToastNotification
          type={notificationProps.type}
          message={notificationProps.message}
          description={notificationProps.description}
          duration={notificationProps.duration}
          style={notificationProps.style}
        />
      )}

      {isModalVisible && (
        <EditDevice
          visible={isModalVisible}
          onClose={closeModal}
          onSave={closeModal}
          // state={selectedUser}
          onEditDeviceUpdate={() => {
            refreshTheData();
            setIsModalVisible(false);
          }}
          selectedDevice={selectedDeviceDetails}
        />
      )}
      <div></div>
      <Table
        columns={columns}
        loading={isLoading}
        dataSource={
          viewMode === "list"
            ? dummyData
            : [
                {
                  key: "map",
                  name: "",
                  value: "",
                  Status: "",
                  Connected: "",
                  Location: "",
                  Organization: "",
                  action: "",
                },
              ]
        }
        onChange={handleTableChange}
        pagination={
          filters.limitnumber && {
            current: filters.pagenumber + 1,
            pageSize: filters.limitnumber,
            total: viewMode === "list" ? deviceCounts.total : 1,
            showTotal: (total, range) =>
              `Showing ${range[0]}-${range[1]} of ${total}`,
            position: ["bottomRight"],
            prevIcon: ["Previous"],
            nextIcon: ["Next"],
            onChange: (page, pageSize) => handlePageSizeChange(page, pageSize),
            showSizeChanger: true,
            locale: {
              items_per_page: "",
            },
          }
        }
        rowKey="key"
        expandedRowRender={
          viewMode === "map"
            ? () => (
                <Grid2 item xs={12} sm={12} md={12} direction="row">
                  <div style={{ height: "40vh" }}>
                    <DevicesMapView
                      compInfo={stateVal?.data}
                      type="location"
                      deviceList={deviceList}
                    />
                  </div>
                </Grid2>
              )
            : undefined
        }
        expandRowByClick={viewMode === "map"}
        expandedRowKeys={viewMode === "map" ? ["map"] : []}
      />
    </div>
  );
};

export default DeviceList;
